/* eslint-disable i18next/no-literal-string -- .*/
import { useIncreaseMaxCommissionLevelMutation } from '@/affiliate-dashboard/graphql';
import { Button } from '@/components/base/button';
import { FormField } from '@/components/base/form/form-field';
import { Input } from '@/components/base/form/input';
import { PageHeading } from '@/components/base/page-heading';
import Section from '@/components/base/section';
import { zodResolver } from '@hookform/resolvers/zod';
import { enqueueSnackbar } from 'notistack';
import { type FormEvent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

const couponSchema = z.object({
  userNumber: z.string(),
  level: z.string(),
});
type Coupon = z.infer<typeof couponSchema>;

export function IncreaseLevel(): JSX.Element {
  const [increaseMaxCommissionLevel, { loading }] =
    useIncreaseMaxCommissionLevelMutation();

  const methods = useForm<Coupon>({
    resolver: zodResolver(couponSchema),
    mode: 'onChange',
  });
  const { handleSubmit, getValues } = methods;

  async function onSubmit(): Promise<void> {
    const { userNumber, level } = getValues();
    try {
      await increaseMaxCommissionLevel({
        variables: {
          userNumber: Number(userNumber),
          level: Number(level),
        },
      });
    } catch (e) {
      if (e instanceof Error) {
        enqueueSnackbar({
          message: e.message,
          variant: 'error',
        });
      }
    }
  }

  function handleClickSubmit(e: FormEvent<HTMLFormElement>): void {
    e.preventDefault();
    return void (async () => {
      handleSubmit(onSubmit)();
    })();
  }

  return (
    <Section variant="secondary" className="max-w-3xl">
      <div className="flex w-full flex-col">
        <PageHeading>Increase Maximum Level</PageHeading>
        <FormProvider {...methods}>
          <form
            onSubmit={(e) => {
              handleClickSubmit(e);
            }}
            className="flex flex-col gap-5"
          >
            <div className="flex w-full flex-col gap-5 sm:flex-row">
              <fieldset className="w-full">
                <FormField label="User Number" name="userNumber">
                  <Input
                    variant="secondary"
                    type="number"
                    placeholder="User Number"
                  />
                </FormField>
              </fieldset>

              <fieldset className="w-full">
                <FormField label="Level" name="level">
                  <Input
                    variant="secondary"
                    type="number"
                    placeholder="Level"
                  />
                </FormField>
              </fieldset>
            </div>

            <div className="flex w-full justify-end">
              <Button loading={loading} type="submit">
                Increase
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
    </Section>
  );
}
